import Isotope from "isotope-layout"
import CategoryCard from "plugin/CategoryShortcuts/CategoryCard"

import IsotopeCards from "plugin/CategoryShortcuts/IsotopeCards"
import MasonryCard from "plugin/CategoryShortcuts/MasonryCard"
import React, {Component} from "react"
import {Card, Container} from "semantic-ui-react"
import cmsStore from "stores/cmsStore"
import "style/CategoryCard.scss"

window["Isotope"] = Isotope

export default class CategoryShortcuts extends Component {

	render() {
		const {category, children = null} = this.props
		const hasData = category && category.children &&  category.children.length > 0
		const title = this.props.title
		const useTitlebar = title && hasData
		const {masonryCategories} = cmsStore.config.plugin
		return (
			<React.Fragment>
				{hasData && children}
				<div className="MasonryContainer">
					{hasData && <div className="">
						{useTitlebar && <h2 className="mt2 ttu">{title}</h2>}
						{masonryCategories && <div>
							{hasData && <IsotopeCards key={category.map_id}>
								<div className="grid-sizer" />
								{category.children.map( subcat => {
									return <MasonryCard
										onReady={this.handleReady}
										hasParents={category.map_id} parents={[category.map_id]} key={subcat.map_id}
										category={subcat} />
								} )}
							</IsotopeCards>
							}
						</div>}

						{!masonryCategories && <div className="mb3">
							<Card.Group itemsPerRow={4} doubling>
								{category.children.map( subcat => {
									if ( !subcat.active ) return null
									if ( subcat.isHidden ) return null
									return <CategoryCard hasParents={category.map_id} parents={[category.map_id]} key={subcat.map_id}
																			 category={subcat} />
								} )}
							</Card.Group>
						</div>}
					</div>}

				</div>
			</React.Fragment>

		)
	}
}



// WEBPACK FOOTER //
// ./src/theme/fiebiger/plugin/CategoryShortcuts/CategoryShortcuts.js